export default "/images/vendor/flag-icon-css/flags/1x1/fo.svg?8b4db68d6e0717fe940e8f23f6bedb8a";